import axios from 'axios'
import store from './store'
import router from './router'
import Vue from 'vue'

const instance = axios.create({
    baseURL: process.env.VUE_APP_BACKEND
})

// Add a request interceptor
instance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('jwt')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
            config.headers['Accept-Language'] = localStorage.getItem('lang')
        } else {
            router.push({ name: 'Login' }, () => {})
        }

        return config
    },
    error => {
        Promise.reject(error)
    }
)

//  Add a response interceptor

instance.interceptors.response.use(
    response => {
        if (response && response.data.status === 'error') {
            store.dispatch('setLoading', false)
            Vue.notify({
                title: router.app.$vuetify.lang.t('$vuetify.branchFormModal.errorMessage'),
                text: response.data.msg,
                type: 'error'
            })
        }

        return response
    }, function (error) {
        if (error && error.response && error.response.status === 401) {
            router.push({ name: 'Login' }, () => {})
            store.dispatch('setErrorModalShow', true)
            store.dispatch('setErrorModalMsg', error.response.data)
            store.dispatch('setLoading', false)

            localStorage.setItem('jwt', null)
            localStorage.setItem('username', null)
        } else if (error && error.response && error.response.status === 500) {
            store.dispatch('setErrorModalShow', true)
            store.dispatch('setErrorModalMsg', error.response.data)
            store.dispatch('setLoading', false)
        }
    })

export default instance
